export default {
  data: function () {
    return {
      editMode: false,
      editModeRef: null
    };
  },
  mounted() {
    this.editModeRef = this.$refs.input;
  },
  watch: {
    editMode: function (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.editModeRef) {
            this.editModeRef.focus();
          }
        });
      }
    }
  }
};